import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useEffect } from 'react';

const useStyle = makeStyles(theme => ({
  imgStyle: {
    height: 200,
    padding: 10,
    userDrag: 'none',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  hidden: {
    display: 'none',
  },
}));

export const HeaderLogo = ({ src, alt }) => {
  const [showLogo, setShowLogo] = useState(true);
  const setLogoSize = () => {
    if (window.scrollY >= 150) {
      setShowLogo(false);
    } else {
      setShowLogo(true);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', setLogoSize);
  });
  const classes = useStyle();
  return (
    <img
      src={src}
      alt={alt}
      className={showLogo ? classes.imgStyle : classes.hidden}
    />
  );
};

HeaderLogo.defaultProps = {
  alt: '#',
};

HeaderLogo.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};
